import axios from "axios";

export default axios.create({
    baseURL: "https://pdfconverter.digitalmetaprime.com:8080/api",//"http://localhost:2000", "http://34.176.21.30"
    headers: {
        "Content-type": "application/json"
    }
});